<template>
  <button
    v-if="pdfData.length === 0"
    type="button"
    class="btn btn-md btn-outline-hover-secondary kt-label-font-color-2--off text-danger"
    @click="downloadPreviewPDF()"
    :disabled="isPDFPreviewing"
  >
    <span v-if="!isPDFPreviewing">
      <font-awesome-icon :icon="['fas', 'eye']" class="mr-1" /> Preview
    </span>
    <span v-else>
      <font-awesome-icon :icon="['fas', 'spinner']" class="mr-1" spin /> Loading preview
    </span>
  </button>
  <button
    v-else
    class="btn btn-md btn-outline-hover-secondary kt-label-font-color-2"
    @click="cancelPreviewPDF"
  >
    <span>
      <font-awesome-icon :icon="['fas', 'chevron-left']" class="mr-1" /> Back
    </span>
  </button>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "FlyerPreviewButton",
  data() {
    return {
      pdfData: '',
      isPDFPreviewing: false,
    };
  },
  props: {
    onLoaded: {
      type: Function,
      default: () => {},
    }
  },
  computed: {
    ...mapGetters({
      opportunityData: 'opportunity/opportunity',
    }),
  },
  methods: {
    cancelPreviewPDF () {
      this.pdfData = ''
      this.onLoaded('')
    },
    downloadPreviewPDF () {
      const payload = {
        uuid: this.$route.params.privateId,
        compressed: false,
        sourceType: 'ITP-FLYER',
        preview: true,
        flyer_option: this.opportunityData.consumer_section.flyer_option || 1
      };

      this.isPDFPreviewing = true
      this.$store
        .dispatch('opportunity/downloadFlyerPDF', payload)
        .then(response => {
          this.pdfData = response
          this.isPDFPreviewing = false
          this.$notification.success('Preview complete!')
          this.onLoaded(response)
        })
        .catch(error => {
          console.error(error)
          this.isPDFPreviewing = false
          this.$notification.error('Preview failed')
          this.onLoaded('')
        })
    },
  },
}
</script>

<style>

</style>
